export const colors = {
  dragButton: '#999',
  expandArrow: '#999',
  primary: '#e43f3f',
};
